import japaneseMessages from '@bicstone/ra-language-japanese';

const fields = {
  names: {
    last_name: '姓',
    first_name: '名',
  },
  password: {
    initial_password: '初期パスワード',
    password: 'New Password',
    password_confirm: 'Confirm',
    password_reset: 'パスワードリセット',
  },
  times: {
    created_at: '作成',
    updated_at: '更新',
    deleted_at: '削除',
    first_login: '初回日時',
    last_login: '最終日時',
  },
  lesson_groups: {
    lesson_group_ids: '所属授業グループ',
    lesson_group_names: '所属授業グループ',
    lesson_group_ids_assigned: '所属授業グループ(担当分)',
  }
}

const jaDomainMessages = {
  resources: {
    labels: {
      ...fields.times,
      profile: 'プロフィール',
      management: '管理',
      password: 'パスワード変更',
      system: 'システム情報',
      history: '履歴',
      password_reset: 'パスワードのリセット',
    },
    schools: {
      name: '学校情報管理',
      fields: {
        name: '学校名',
        address: '住所',
        classification: '学校区分',
        max_supervisors: '最大教師数',
        max_players: '最大生徒数',
      }
    },
    supervisors: {
      name: '教師アカウント管理',
      fields: {
        ...fields.names,
        ...fields.password,
        ...fields.lesson_groups,
        role: '権限',
      },
      button: {
        transfer_owner: 'Ownerにする',
      }
    },
    players: {
      name: '生徒アカウント管理',
      fields: {
        ...fields.names,
        ...fields.password,
        ...fields.lesson_groups,
        grade: '学年',
        school_class: 'クラス',
        student_id: '学籍番号',
        login_id: 'ログインID',
        cleared_chapters: '完了状況',
        file: 'ファイル',
        restore: '削除を取消す',
        show_deleted: '削除を表示',
      }
    },
    lesson_groups: {
      name: '授業グループ管理',
      fields: {
        name: '名称',
        supervisors_count: '所属教師数',
        players_count: '所属生徒数',
      }
    },
    profiles: {
      fields: {
        ...fields.password,
      },
    },
    student_files: {
      name: '生徒アカウント',
      notes: {
        note1: 'ファイルはカンマ区切りのCSVで作成してください。',
        note2: '1行目はヘッダ行として取り込みません。',
        note3: '各項目の内容は下記になります。',
        multi: '複数カラム',
      },
    },
    errors: {
      password_mismatch: 'パスワードが一致していません',
      email_already_exists: '登録済のメールアドレスです',
      email_mismatch: 'メールアドレスが一致していません',
    },
    messages: {
      delete_title: "「%{name}」を削除",
      transfer_owner: {
        title: 'Owner権限委譲',
        content: "「%{name}」をOwnerにします。よろしいですか？",
      },
      password_reset: {
        success: 'パスワードリセット完了',
        send: 'メールアドレスにアカウント情報を送付しました。',
      }
    },
  },
  ra: {
    ...japaneseMessages.ra,
    action: {
      ...japaneseMessages.ra.action,
      create: "新規作成",
      export: "CSV Export",
      import: "CSV Import",
      send: "送信",
    },
    auth: {
      ...japaneseMessages.ra.auth,
      email: 'メールアドレス',
      input_new_password: '新しくパスワードを設定してください',
      password_reset: 'パスワードを忘れた方はコチラ',
      email_confirm: 'メールアドレス（確認用）',
    },
    page: {
      ...japaneseMessages.ra.page,
      empty: '%{name} データは、まだ作成されていません',
      invite: '作成してください',
    },
    notification: {
      ...japaneseMessages.ra.notification,
      transfer_owner_completed: 'Owner変更処理が完了しました。',
      send: '送信しました',
    }
  }
};

export default {
  ...japaneseMessages,
  ...jaDomainMessages
};
